export default __webpack_public_path__ + "static/media/tick.446ad2e5.svg";